import Vue from 'vue';
import { SelectionType } from '../model/ProductDto';
export default Vue.extend({
    props: {
        variants: Array,
        selectedVariant: Object,
    },
    data() {
        return {
            SelectionType: SelectionType,
        };
    },
    methods: {
        onVariantSelect(variantItem) {
            this.$emit('selectedVariantChange', variantItem);
        },
    },
});
